import {AEditor} from "@/views/editor/service/editor";
import {reactive} from "vue";
import {IActivityThemeImage} from "@/model/activity";
import {api} from "@/lib/api";
import {ServiceOrder} from "@/model/order";
import {Modal} from "ant-design-vue";
import {ThemeCategory} from "@/views/editor/service/theme/category";

export interface IThemeImagePreview {
    preview: string;
    loading: boolean;
}

export interface IThemeImageCategory {
    title: string;
    previews: IThemeImagePreview[];
}

export interface IThemeEditorImage {
    image: IActivityThemeImage
    preview: IThemeImagePreview
}

export class Theme {
    readonly noPic = 'https://static.pms.guandb.cn/media/system/null.jpg'
    readonly active = reactive({
        categories: [
            {title: '头图', previews: [] as IThemeImagePreview[]},
            {title: '分享缩略', previews: [] as IThemeImagePreview[]},
            {title: '分享海报', previews: [] as IThemeImagePreview[]},
            {title: '背景图', previews: [] as IThemeImagePreview[]},
        ] as IThemeImageCategory[],
        open: false,
        service: {serviceOrder: null as null | ServiceOrder},
    })
    category: ThemeCategory | null = null;

    constructor(readonly editor: AEditor) {
        editor.meta.theme.images.forEach((i, k) => {
            this.active.categories[k].previews = i.map(() => ({
                preview: this.noPic,
                loading: true
            }))
        })
    }

    async refresh(): Promise<void> {
        for (const [x, y] of this.editor.meta.theme.keys.entries()) {
            await this.imagePreview(x, y)
        }
    }

    async imagePreview(x: number, y: number): Promise<unknown> {
        if (this.editor.meta.theme.images[x][y].draws.length == 0) {
            this.active.categories[x].previews[y].loading = false;
            return Promise.resolve()
        } else {
            this.active.categories[x].previews[y].loading = true;
        }

        return api<unknown, Blob>({
            url: `user/${this.editor.userAgent.meta.account.agent_id}/activity/image/preview`,
            method: 'POST',
            data: {activity: this.editor.meta, branch_id: this.editor.active.preview.branch_id, image: this.editor.meta.theme.images[x][y]},
            responseType: 'blob'
        }).then((b: Blob) => {
            this.active.categories[x].previews[y].preview = URL.createObjectURL(b);
        }).finally(() => {
            this.active.categories[x].previews[y].loading = false;
        });
    }

    onSetting(x: number) {
        this.category = new ThemeCategory(this, x)
        this.active.open = true
    }

    onOrderShow () {
        this.editor.userAgent.newOrder('订制元素', this.editor.meta.activity_id).then((so) => {
            this.active.open = false
            this.active.service.serviceOrder = so
        }).catch((error) => Modal.error({content:error.message}))
    }
}
